"use client";

import { cn } from "@frontend/shared/lib/utils";
import { ArrowDown } from "lucide-react";
import { PRODUCT_PAGE_SECTIONS_ID } from "./product-page-sections";

interface LearnMoreButtonProps {
  label?: string;
  primaryColor?: string;
  targetId?: string;
  className?: string;
}

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false);

export const LearnMoreButton = ({
  label,
  primaryColor,
  targetId = PRODUCT_PAGE_SECTIONS_ID,
  className,
}: LearnMoreButtonProps) => {
  const trimmedLabel = label?.trim();
  if (!trimmedLabel) return null;

  const color = primaryColor ?? "#000000";

  const handleClick = () => {
    const target = document.getElementById(targetId);
    if (!target) return;
    target.scrollIntoView({
      behavior: prefersReducedMotion() ? "auto" : "smooth",
      block: "start",
    });
    // Move focus with the scroll; preventScroll keeps it from cutting the
    // smooth scroll short.
    target.focus({ preventScroll: true });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        "w-full rounded-full h-[64px] flex justify-center items-center gap-2 text-lg bg-white border transition-all duration-200",
        "hover:!bg-black hover:!text-white hover:!border-black",
        className,
      )}
      style={{ color, borderColor: color }}
    >
      <span>{trimmedLabel}</span>
      <ArrowDown aria-hidden="true" className="h-5 w-5" />
    </button>
  );
};
